// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"s2","account_subscription_card_img":"t2","account_subscription_card_lower_section":"u2","account_subscription_card_category":"v2","account_subscription_card_title":"w2","account_subscription_card_price_section":"x2","account_subscription_card_servings":"y2","account_subscription_card_prices":"z2","account_subscription_card_price":"A2","account_subscription_card_price_actual":"B2"};
    if(module.hot) {
      // 1738064243773
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  